import { store } from '@/store/store'
export default class LocaleHelper {
    public static formatDecimal(value: number | string): string {
        const currentLanguage = store.getters.activeLang

        if (typeof value === 'number') {
            value = value.toString()
        }

        if (currentLanguage !== "en") {
            value = value.replace(".", ",")
            value = value.replace(".", ",")
        }

        return value
    }
}
